import { http } from '@/_services/http.service'

function get (zipcode, housenumber) {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  }

  const url = `${process.env.VUE_APP_API_URL}/zipcode&zipcode=${zipcode}&housenumber=${housenumber}`

  return http.fetch(url, requestOptions).then(response => response.json()).then(result => { return result })
}

function getAddress(zipcode, housenumber){
  zipcode = zipcode.replace(' ', '')
  zipcode = zipcode.toUpperCase()

  const notFound = {
    street: 'Adres niet gevonden',
    city: '',
    zipcode: zipcode
  }

  if(zipcode.length !== 6 || !(housenumber.length > 0)){
    return notFound
  }

  return geodataService.get(zipcode, housenumber).then(data => {
    if ('exception' in data || 'errors' in data) {
      return notFound
    } else {
      data.zipcode = zipcode
      return data
    }
  })

}
export const geodataService = {
  get, getAddress
}


/* Switch to this one once we're live */

/*
import { authHeader } from '../_helpers'

function get (postcode, housenumber) {
  return authHeader().then(function (token) {
    const requestOptions = {
      method: 'GET',
      headers: token
    }

    return window.fetch(`${process.env.VUE_APP_API_URL}/postcode&postcode=${postcode}&housenumber=${housenumber}`, requestOptions).then(function (response) {
      return response.text().then(text => {
        const data = text && JSON.parse(text)
        return data
      })
    })
  })
}
export const geodataService = {
  get
}*/
